import { get } from '@/api/request';

// 左侧tag列表
export const tagList = (params) => get("tagList", params);

// tag专题信息
export const tagInfoById = (params) => get("tagInfoById", params);